export const AUTH_INIT = 'AUTH_INIT';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_SIGNOUT = 'AUTH_SIGNOUT';
export const REDIRECTED_TO_AUTH_PAGE = 'REDIRECTED_TO_AUTH_PAGE';
